<oth-card [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate" [headerTemplate]="headerTemplate"
          class="policy-card">
  <!-- Header -->
  <ng-template #headerTemplate>
    <ng-container *ngTemplateOutlet="policyHeader || defaultPolicyHeader">
      <!-- Header of the card -->
    </ng-container>
    <ng-template #defaultPolicyHeader>
      <div *ngIf="defaultHeaderContent" class="header">
        {{ defaultHeaderContent }}
      </div>
    </ng-template>
  </ng-template>

  <!-- Body -->
  <ng-template #bodyTemplate>
    <div class="body">
      <ng-container *ngTemplateOutlet="policyBody || defaultPolicyBody">
        <!-- Body of the card -->
      </ng-container>
      <ng-template #defaultPolicyBody>
        <div *ngIf="defaultBodyContent" class="body">
          {{ defaultBodyContent }}
        </div>
      </ng-template>
    </div>
  </ng-template>

  <!-- Footer -->
  <ng-template #footerTemplate>
    <div class="footer">
      <img [src]="BRAND.logo.main" alt="logo" class="brand-logo">
      <small>{{ BRAND.name }} <span class="copyright">© 2023</span></small>
    </div>
  </ng-template>
</oth-card>
